import { useEffect, useState } from 'react';
// material
import { Button, Container } from '@material-ui/core';
import { Icon } from '@iconify/react';
import backFill from '@iconify/icons-eva/arrow-back-fill';
// eslint-disable-next-line import/no-unresolved
import FileManagementUpload from 'src/components/_dashboard/file-manager/MasterFileUpload';
// eslint-disable-next-line import/no-unresolved
import FileManagementList from 'src/components/_dashboard/file-manager/MasterFileList';

// routes
import {
  getCategoryListByProject,
  getFileCategoryList,
  resetCategoryListByProject
  // eslint-disable-next-line import/no-unresolved
} from 'src/redux/slices/filecategory';
import { getProjectList } from '../../redux/slices/project';
import { getMasterFileData } from '../../redux/slices/masterfile';
import { getClientList, getProjectListByClient, resetProjectListByClient } from '../../redux/slices/client';
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
//  redux
import { useDispatch, useSelector } from '../../redux/store';
// components
import Page from '../../components/Page';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';

// ----------------------------------------------------------------------

export default function FileManagement() {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const { masterFileData, isLoading } = useSelector((state) => state.filemanager);

  const [editId, setEditId] = useState('');
  const [deleteId, setDeleteId] = useState([]);
  const [visibleComponent, setVisibleComponent] = useState('List');
  const [currentMasterFile, setCurrentMasterFile] = useState({});

  useEffect(() => {
    dispatch(getMasterFileData());
    dispatch(getClientList(true));
    dispatch(getProjectList(true));
    dispatch(getFileCategoryList(true));
    dispatch(resetProjectListByClient());
    dispatch(resetCategoryListByProject());
  }, [dispatch]);

  useEffect(() => {
    setVisibleComponent('List');
  }, []);

  useEffect(() => {
    if (editId) {
      setVisibleComponent('Edit');
      const tempMasterFile = masterFileData.find((masterData) => masterData.id === editId);
      dispatch(getProjectListByClient(tempMasterFile?.client?.id));
      dispatch(getCategoryListByProject(tempMasterFile?.project?.id));
      setCurrentMasterFile(tempMasterFile);
    } else setVisibleComponent('List');
  }, [editId]);

  useEffect(() => {
    if (visibleComponent !== 'Edit') setEditId('');
  }, [visibleComponent]);

  const setComponentList = (e) => {
    setVisibleComponent('List');
    e.preventDefault();
  };

  return (
    <Page title="Master File | Smart Collect">
      <Container maxWidth={themeStretch ? false : 'lg'} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
        <HeaderBreadcrumbs
          heading="Master File"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            {
              name: 'Master File',
              href: PATH_DASHBOARD.general.master_file,
              handleClick: (e) => {
                setComponentList(e);
              }
            },
            {
              name: visibleComponent === 'List' ? visibleComponent : visibleComponent
            }
          ]}
          action={
            visibleComponent === 'List' ? (
              <Button
                variant="contained"
                onClick={() => {
                  setVisibleComponent('Create');
                }}
              >
                Upload File
              </Button>
            ) : (
              <Button
                variant="contained"
                onClick={() => {
                  setVisibleComponent('List');
                }}
                startIcon={<Icon icon={backFill} />}
              >
                List
              </Button>
            )
          }
        />
        {visibleComponent === 'Create' && <FileManagementUpload setVisibleComponent={setVisibleComponent} />}
        {visibleComponent === 'List' && (
          <FileManagementList setEditId={setEditId} deleteId={deleteId} setDeleteId={setDeleteId} loading={isLoading} />
        )}
        {visibleComponent === 'Edit' && (
          <FileManagementUpload
            editId={editId}
            setVisibleComponent={setVisibleComponent}
            currentMasterFile={currentMasterFile}
          />
        )}
      </Container>
    </Page>
  );
}
